import { jsx as _jsx } from "react/jsx-runtime";
import { useAskInputSearchModeModelController } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputSearchModeModelController.js';
import { useComputerModelChip } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useComputerModelChip.js';
import { AskInputModelSelector } from '#pplx/frontend/apps/ask/ask-input/model-selector/AskInputModelSelector.js';
import { resolveModelPickerControl } from '#pplx/frontend/apps/ask/ask-input/model-selector/resolveModelPickerControl.js';
import { useTextOnlyModelHandler } from '#pplx/frontend/apps/ask/hooks/search-model-selection-hooks/useTextOnlyModelHandler.js';
import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { ComputerModelChip } from '#pplx/frontend/apps/ask/search-models-menu/ComputerModelChip.js';
import { useSearchModels } from '#pplx/frontend/ask-models/hooks/useSearchModels.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import React from 'react';
export const ModelPickerSlot = ({ querySource, isFollowUp, showModelSelector = true, modelSelectorOverrides, showComputerModelChip = true, searchModel, onSearchModelSelect, onSearchModelDeselect, computerModelChipModelOverride, computerEffortPreferences, computerEffortEnabled, onComputerEffortPreferencesChange, localMode, triggerAccessory, restrictions, }) => {
    const { searchModelProps, selectedSearchMode, selectedModel, setSelectedModel } = useAskInputSearchModeModelController({
        searchModel,
        onSearchModelSelect,
        onSearchModelDeselect,
    });
    // `restrictions` only gates future picks; like the legacy input, an image that rules out
    // text-only models also moves an already selected one to the default.
    useTextOnlyModelHandler({
        hasImageAttachments: restrictions?.allowTextOnlyModels === false,
        selectedModel,
        onModelSwitch: setSelectedModel,
    });
    const { configuredModel } = useThreadConfig();
    const { supportsModelSwitching } = useSearchModels({ reason: 'xplat-composer-model-picker' });
    // A fork starts a new thread, so it gets the full picker, not the chip.
    const isComputerModeFollowUp = isFollowUp && querySource !== 'fork';
    const computerModelChip = useComputerModelChip({
        configuredModel: computerModelChipModelOverride ?? configuredModel,
        isFollowUp: isComputerModeFollowUp,
    });
    const resolvedControl = resolveModelPickerControl(showComputerModelChip && computerModelChip.showComputerModelChip
        ? {
            kind: 'computer-orchestrator',
            orchestrator: computerModelChip.model,
            isModelSelectionEnabled: searchModelProps.enabled,
            computerEffortPreferences,
            supportsModelSwitching,
        }
        : {
            kind: 'mode-model',
            showModelSelector,
            isModelSelectionEnabled: searchModelProps.enabled,
            selectedSearchMode,
        });
    const control = modelSelectorOverrides !== undefined
        ? { kind: 'dropdown', trackModelSelection: false }
        : resolvedControl;
    switch (control.kind) {
        case 'dropdown':
            return (_jsx(AskInputModelSelector, { querySource: querySource, restrictions: restrictions, localMode: localMode, computerEffortPreferences: computerEffortPreferences, computerEffortEnabled: computerEffortEnabled, onComputerEffortPreferencesChange: onComputerEffortPreferencesChange, triggerAccessory: triggerAccessory, ...searchModelProps, ...modelSelectorOverrides, searchMode: selectedSearchMode, trackModelSelection: control.trackModelSelection }));
        case 'chip':
            return _jsx(ComputerModelChip, { model: control.model });
        case 'none':
            return null;
        default:
            return assertUnreachableValue(control);
    }
};
//# sourceMappingURL=modelPickerPluginComponents.js.map